import { render } from "./TheTarrifes.vue?vue&type=template&id=75b24dee&scoped=true"
import script from "./TheTarrifes.vue?vue&type=script&lang=js"
export * from "./TheTarrifes.vue?vue&type=script&lang=js"

import "./TheTarrifes.vue?vue&type=style&index=0&id=75b24dee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b24dee"]])

export default __exports__